import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faChevronLeft,
  faPlus,
  faCheckCircle,
  faTimesCircle,
  faExclamationCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './App.vue';
import './assets/custom.scss'; // imports bootstrap css and global styles
import router from './router';
import store from './store/index';

library.add(faChevronLeft, faPlus, faCheckCircle, faTimesCircle, faExclamationCircle);

Vue.use(BootstrapVue);

Vue.component('FontAwesomeIcon', FontAwesomeIcon);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
